import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../msal';

export default new PublicClientApplication(msalConfig);
